module.exports = __webpack_public_path__ + "static/media/undraw_ai-data-extraction_soxc.1e1dd694.svg";